<script setup lang="ts">
import type SiteBanner from '@store/content/entities/SiteBanner';

const { banner } = defineProps<{
    banner?: SiteBanner;
    reserveType: string;
    origin?: string;
    destination: string;
}>();

const mobileHeight = computed(
    () =>
        `${
            ((banner?.desktopHeight ?? 550) / (banner?.desktopWidth ?? 1000)) *
            90
        }vw`
);
const desktopHeight = computed(
    () =>
        `${
            ((banner?.desktopHeight ?? 550) / (banner?.desktopWidth ?? 1000)) *
            40
        }vw`
);
const maxHeight = computed(
    () =>
        `${
            ((banner?.desktopHeight ?? 500) / (banner?.desktopWidth ?? 1000)) *
            600
        }px`
);
</script>
<template>
    <div class="list-loading-container">
        <div class="list-loading-content">
            <mr-blur-hash-image
                :src="banner?.desktopImageUrl"
                :hash="banner?.desktopBlurhash"
                class="loading-image"
                preload
                image-fit="contain"
            />
            <div class="footer-wrapper">
                <mr-dots-loading color="var(--blue-400)" :size="8" />
                مِستربلیط در حال یافتن بهترین {{ reserveType }}‌های
                {{ origin || destination }}
                {{ origin ? `به ${destination}` : '' }} برای شما می‌باشد.
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.list-loading-container {
    position: fixed;
    inset: 0 0 0 0;
    background-color: rgba($color: usePalette(), $alpha: 0.2);
    z-index: 2147483647;
    display: flex;
    align-items: center;
    justify-content: center;
    .list-loading-content {
        @include shadow-level4();
        border-radius: 16px;
        overflow: hidden;
        background-color: white;

        width: 40vw !important;
        max-width: 600px !important;
        @include mobile-only() {
            width: 90vw !important;
        }
        .footer-wrapper {
            @include tg-l();
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            padding: 0 8px;
        }

        .loading-image {
            width: 40vw !important;
            height: v-bind(desktopHeight) !important;
            max-width: 600px !important;
            max-height: v-bind(maxHeight) !important;
            @include mobile-only() {
                height: v-bind(mobileHeight) !important;
                width: 90vw !important;
            }
        }
    }
}
</style>
